import { useCallback, useRef, useState } from "react";

import { useClickOutside } from "../../../hooks/useClickOutside";
import { useKeydownListener } from "../../../hooks/useKeydownListener";

interface EquipmentsProps {
  features: {
    value: string;
    feature?: {
      feature_name: string;
    };
  }[];
}
export function Equipments({ features }: EquipmentsProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  const [showTooltip, setShowTooltip] = useState<string | null>(null);

  const iconTranslate = {
    carIconPerson: "orm_icon_sitzer",
    carIconDoor: "orm_icon_tuerer",
    carIconLuggage: "orm_icon_luggage",
    carIconGear: "orm_icon_automatik",
    carIconGearManual: "orm_icon_gear",
    carIconSnow: "orm_icon_klima",
    carIconTow: "orm_icon_ahk",
    carIconWeight: "orm_icon_weight",
    carIconBox: "orm_icon_lkwkoffer",
    carIconLabel: "orm_icon_co2",
    carIconNavi: "orm_icon_navi",
    carIconPass: "orm_icon_pass",
    null: "orm_icon_navi",
  } as any;

  function handleClose(event: MouseEvent | TouchEvent): void {
    setShowTooltip(null);
  }

  const handleKeyInteraction = (
    event: React.KeyboardEvent,
    featureId: string,
  ) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setShowTooltip(showTooltip === featureId ? null : featureId);
    }

    if (event.key === "Tab" || event.key === "Escape") {
      setShowTooltip(null);
    }
  };

  useClickOutside(containerRef, handleClose);
  if (features.length > 0) {
    const content = (
      <div
        className="orm-equip__icons orm-equip__txt__icons orm-mb-0"
        ref={containerRef}
      >
        {features.map((feature: any) => (
          <span
            key={feature.id}
            data-key={feature.id}
            className="orm-equip__icon  orm-mr-12 orm-relative"
            title={`${feature.feature?.feature_name}: ${feature.value}`}
            onClick={(e) => {
              e.stopPropagation();
              setShowTooltip(showTooltip === feature.id ? null : feature.id);
            }}
            onKeyDown={(e) => handleKeyInteraction(e, feature.id)}
            tabIndex={0}
            role="button"
          >
            {feature.value === "Manuell" || feature.value === "manuell" ? (
              <i className="orm_icon_gear" aria-hidden="true"></i>
            ) : (
              <i
                className={iconTranslate[feature.feature!.css_icon]}
                aria-hidden="true"
              ></i>
            )}
            {!isNaN(feature.value) && (
              <span className=" orm-ml-4 orm_icontext_additional">
                {feature.value}
              </span>
            )}
            {showTooltip == feature.id && (
              <span className="orm-eqiupment__tooltip-bottom" role="tooltip">
                {feature.feature?.feature_name}: {feature.value}
              </span>
            )}
          </span>
        ))}
      </div>
    );

    return content;
  }

  return <></>;
}

export default Equipments;
